import styled from 'styled-components';

export const StyledTodayEntryModal = styled.div`
  padding: 24px 28px;

  > div {
    > div {
      > .MuiTableContainer-root {
        min-height: calc(500px - 60px);
        max-height: calc(500px - 60px);
      }
    }
  }
`;
